import { render } from "./withdrawProcess.vue?vue&type=template&id=57a1f2e3&scoped=true&ts=true"
import script from "./withdrawProcess.vue?vue&type=script&lang=ts"
export * from "./withdrawProcess.vue?vue&type=script&lang=ts"

import "./withdrawProcess.vue?vue&type=style&index=0&id=57a1f2e3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a1f2e3"]])

export default __exports__